import { OrderProvider, SimpleOrderProvider } from "@app/provider";
import { routes } from "@app/routing";
import React, { FC } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SimpleOrderRouting from "./simpleOrderRouting";

type Params = {
  orderUidPublic: string;
};

const SimpleOrder: FC = () => {
  const { orderUidPublic } = useParams<keyof Params>() as Params;

  const navigate = useNavigate();

  if (!orderUidPublic) {
    navigate(routes.home, { replace: true });
  }

  //ToDo Need to use SimpleOrderProvider only (refactoring)
  return (
    <OrderProvider orderUidPublic={orderUidPublic}>
      <SimpleOrderProvider orderUidPublic={orderUidPublic}>
        <SimpleOrderRouting />
      </SimpleOrderProvider>
    </OrderProvider>
  );
};

export default SimpleOrder;
